import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container px-4 mx-auto text-left pt-10 lg:pb-10 flex justify-center items-start" }
const _hoisted_2 = { class: "w-full lg:w-2/3 xl:w-1/2 mt-8" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Podaj nowe hasło ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "password" }, "Hasło", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "passwordConfirmation" }, "Powtórz hasło ", -1)
const _hoisted_6 = { class: "my-8 grid sm:grid-cols-2 gap-4" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Zmień hasło ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Powrót na stronę logowania ")
const _hoisted_9 = { class: "text-center text-sm" }

import { ref } from 'vue'
import { UiButton, UiHeading, UiInput, UiTitle } from '@/components/common/ui'
import { useAuth } from '@/composables/useAuth'
import { useRouter, useRoute } from 'vue-router'
import { useNotifications } from '@/composables/useNotifications'
import { Form } from 'vee-validate'
import * as Yup from 'yup'
import { ButtonTypes } from '@/types/enums/button'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { resetPasswordStep2, loading } = useAuth()
const router = useRouter()
const route = useRoute()
const { pushFail, pushSuccess } = useNotifications()

const password = ref<string>('')
const passwordRepeat = ref<string>('')
const token = route.params.token.toString()
const version = ref<string>(`v${process.env.PACKAGE_VERSION}`)
const handleBack = () => {
    router.push({ name: 'login' })
}
const handleResetPassword = async () => {
    try {
        await resetPasswordStep2(token, password.value, passwordRepeat.value)
        pushSuccess('Twoje hasło zostało zmienione')
        handleBack()
    } catch (error) {
        if (error instanceof Error) {
            pushFail(error.message)
        }
    }
}
const schema = Yup.object().shape({
    password: Yup.string().required(),
    passwordConfirmation: Yup.string()
        .required()
        .oneOf([Yup.ref('password')], 'Hasła muszą być takie same'),
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(UiHeading), { title: "Reset hasła" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(UiTitle), { class: "mb-8" }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_unref(Form), {
          "validation-schema": _unref(schema),
          onSubmit: handleResetPassword
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _hoisted_4,
              _createVNode(_unref(UiInput), {
                id: 'password',
                modelValue: password.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event)),
                placeholder: "Podaj hasło",
                "input-name": "password",
                type: "password"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", null, [
              _hoisted_5,
              _createVNode(_unref(UiInput), {
                id: 'passwordConfirmation',
                modelValue: passwordRepeat.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((passwordRepeat).value = $event)),
                placeholder: "Powtórz hasło",
                "input-name": "passwordConfirmation",
                type: "password"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(UiButton), {
                loading: _unref(loading),
                primary: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["loading"]),
              _createVNode(_unref(UiButton), {
                type: _unref(ButtonTypes).BUTTON,
                onClick: handleBack
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }, 8, ["type"])
            ])
          ]),
          _: 1
        }, 8, ["validation-schema"]),
        _createElementVNode("div", _hoisted_9, _toDisplayString(version.value), 1)
      ])
    ])
  ], 64))
}
}

})